// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 50px;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  width: 100%;
}

.detail-form {
  height: 100%;
}

.remove-button {
  margin-left: 10px;
}

.secondary {
  margin-left: 5px;
}

.verified-reference-number {
  color: green;
  margin-left: 5px;
}

.unverified-reference-number {
  color: red;
  margin-left: 5px;
}

.flex-container {
  display: flex;
  align-items: stretch;
}

.trade-goods-div {
  margin-bottom: 15px;
}

textarea.disabled {
  background-color: gray !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
